import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { userService } from "../services/userService";
import {
  handleAuthResponse,
  handleKioskoAuthResponse,
} from "../services/auth.js";
import { useNavigate } from "react-router-dom";
import { spinnerStore } from "../context/spinnerStore";
import { userStore } from "../store/userStore";
import { authModalStore } from "../context/authModalStore.js";
import axiosInstance from "../services/api.js";
import { showAlert } from "../utils/Alert.js";

const {
  REACT_APP_ENVIRONMENT: ENVIRONMENT,
  REACT_APP_KIOSK_TOKEN: KIOSK_TOKEN,
} = process.env;

export const useUserLogin = () => {
  const queryClient = useQueryClient();
  const showSpinner = spinnerStore((state) => state.showSpinner);
  const hideSpinner = spinnerStore((state) => state.hideSpinner);
  const handleClose = authModalStore((state) => state.handleClose);

  return useMutation({
    mutationFn: async (user) => await userService.login(user),
    onMutate: () => {
      showSpinner("Ingresando...");
    },
    onSuccess: (response) => {
      if (!response.data.token || !response.data.user) {
        console.error("problema con la estructura:", response.data);
        return;
      }
      handleAuthResponse(response.data);
      queryClient.invalidateQueries({ queryKey: ["MembershipStatus"] });
      handleClose();
    },
    onError: (error) => {
      console.error("Error al Ingresar:", error);
    },
    onSettled: () => {
      hideSpinner();
    },
  });
};

export const useTheaterUserLogin = () => {
  const navigate = useNavigate();
  const showSpinner = spinnerStore((state) => state.showSpinner);
  const hideSpinner = spinnerStore((state) => state.hideSpinner);
  const { setKioskData } = userStore.getState();

  return useMutation({
    mutationFn: async (user) => {
      return await axiosInstance.post("login", user);
    },
    onMutate: () => {
      showSpinner("Ingresando...");
    },
    onSuccess: (response) => {
      const { token, user } = response.data;
      if (!token || !user || !user.complement.printer_name) {
        showAlert({
          text: "No tienes permisos para acceder a esta aplicación.",
        });
        return;
      }

      setKioskData(user);
      handleKioskoAuthResponse(response.data);
      navigate("/banners");
    },
    onError: (error) => {
      console.error("Error al Ingresar:", error);
      showAlert({
        text: "Valida que tus credenciales sean correctas.",
      });
    },
    onSettled: () => {
      hideSpinner();
    },
  });
};

const removeAuthTokens = () => {
  userStore.getState().clearUserData();
  localStorage.removeItem(ENVIRONMENT);
  localStorage.removeItem(KIOSK_TOKEN);
  window.location.href = "/";
};

export const useUserLogout = () => {
  const showSpinner = spinnerStore((state) => state.showSpinner);
  const hideSpinner = spinnerStore((state) => state.hideSpinner);

  return useMutation({
    mutationFn: async () => await userService.logout(),
    onMutate: () => {
      showSpinner("Cerrando sesión...");
    },
    onSuccess: () => {
      removeAuthTokens();
    },
    onError: (error) => {
      console.error("Error al cerrar sesión:", error);
      removeAuthTokens();
    },
    onSettled: () => {
      hideSpinner();
    }
  });
};
